import { Component, OnInit } from '@angular/core';
import * as xlsx from 'xlsx';
import { InvoiceService } from 'src/app/services/invoice.service';
import { Company } from 'src/app/models/company';
import { CompanyService } from 'src/app/services/company.service';
import { AccessService } from 'src/app/services/access.service';
import { DatePipe } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-reprint-invoice-dnit-massive',
  templateUrl: './reprint-invoice-dnit-massive.component.html',
  styleUrls: ['./reprint-invoice-dnit-massive.component.scss'],
  providers: [UtilsService, InvoiceService, CompanyService, AccessService]
})
export class ReprintInvoiceDnitMassiveComponent implements OnInit {
  loading: boolean;
  pipeFecha = new DatePipe('en-US');
  company = {} as Company;

  public isReprint: boolean = false;
  public isDisabled: boolean = false;
  public begDate: string;
  public endDate: string;
  public userCode: number;
  public storeCode: number;
  public companyCode: number;
  public storeName: string;
  public entries: number = 10;
  public activeRow: any;
  public temp: any[] = [];
  public invoiceList: any[] = [];
  public selected: any[] = [];
  public totalSuccess: number = 0;
  public totalErrors: number = 0;

  public settings = {
    columns: {
      correlativo: { title: 'Correlativo' },
      fecha: { title: 'Fecha' },
      cliente: { title: 'Cliente' },
      comentario: { title: 'Tipo' },
      invoiceAuthorization: { title: 'CDC' },
      total: { title: 'Total', type: 'number' },
      downloadStatus: { title: 'Resultado' }
    }
  };

  constructor(
    private _utilsService: UtilsService,
    private _invoiceService: InvoiceService,
    private _companyService: CompanyService,
    private _accessService: AccessService
  ) { }

  async ngOnInit() {
    const _data = JSON.parse(localStorage.getItem('data'));
    this.storeName = _data.storeName ? _data.storeName.toString() : null;
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    this.begDate = this._utilsService.dateTime('yyy-MM-dd');
    this.endDate = this._utilsService.dateTime('yyy-MM-dd');

    await this.getCompany(this.companyCode);
  }

  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    const val = $event.target.value.toLowerCase();
    this.temp = this.invoiceList.filter(d => {
      for (const key in d) {
        if (d[key] !== null && d[key].toString().toLowerCase().indexOf(val) !== -1) {
          return true;
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  onSelect(event) {
    this.selected = event.selected;
  }

  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => console.log(error)
    );
  }

  getAll() {
    this.totalSuccess = 0;
    this.totalErrors = 0;
    this.selected = [];
    this.isDisabled = true;

    if (!this.begDate || !this.endDate) {
      this.isDisabled = false;
      this._utilsService.showNotification(2, 'Ingresar Datos');
      return;
    }

    this.loading = true;
    const json = { storeCode: this.storeCode, begDate: this.begDate, endDate: this.endDate };

    this._invoiceService.getAllByCompany(json).then(
      async (response) => {
        if (response.result == true) {
          this.invoiceList = response.records.map(invoice => ({
            ...invoice,
            comentario: invoice.comentario === '' ? 'NORMAL' : invoice.comentario,
            total: Math.floor(invoice.total),
            downloadStatus: '',
          }));
          this.invoiceList.sort((a, b) => a.invoiceInternNumber - b.invoiceInternNumber);
          this.temp = [...this.invoiceList];
          this.isReprint = true;
          this.isDisabled = false;
          this._utilsService.showNotification(1, response.message);
        } else {
          this.isDisabled = false;
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        this.isDisabled = false;
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => { this.loading = false; });
  }

  // Regenera las facturas seleccionadas; si no hay selección, usa todas las de la tabla
  async regenerateMassive() {
    const target: any[] = this.selected.length > 0 ? this.selected : this.temp;

    if (target.length === 0) {
      this._utilsService.showNotification(2, 'No hay facturas para procesar');
      return;
    }

    this.totalSuccess = 0;
    this.totalErrors = 0;
    this.isDisabled = true;

    for (const row of target) {
      this.loading = true;
      try {
        const response: any = await this._invoiceService.regeneratePdf(this.buildBody(row));
        await this.downloadUrlS3(response.records.signedUrlPdf, this.buildFileName(row), 'pdf');
        this.totalSuccess++;
        row.downloadStatus = 'Exitoso';
        this._utilsService.showNotification(1, 'PDF descargado: ' + row.correlativo);
      } catch (error) {
        this.totalErrors++;
        row.downloadStatus = typeof error === 'string' ? error : (error.message || JSON.stringify(error));
        this._utilsService.showNotification(2, 'Error en correlativo ' + row.correlativo + ': ' + error);
        console.log('Error row:', row, error);
      } finally {
        this.loading = false;
        this.temp = [...this.temp];
      }
      await new Promise(resolve => setTimeout(resolve, 2000));
    }

    this.isDisabled = false;
    this._utilsService.showNotification(
      1,
      `Proceso finalizado. Exitosas: ${this.totalSuccess}, Errores: ${this.totalErrors}`
    );
  }

  // Regenera y descarga una sola factura desde la fila
  async regenerateSingle($event, row) {
    $event.preventDefault();
    this.loading = true;
    this.isDisabled = true;

    try {
      const response: any = await this._invoiceService.regeneratePdf(this.buildBody(row));
      await this.downloadUrlS3(response.records.signedUrlPdf, this.buildFileName(row), 'pdf');
      row.downloadStatus = 'Exitoso';
      this._utilsService.showNotification(1, 'PDF descargado correctamente');
    } catch (error) {
      row.downloadStatus = typeof error === 'string' ? error : (error.message || JSON.stringify(error));
      this._utilsService.showNotification(2, error);
      console.log(error);
    } finally {
      this.temp = [...this.temp];
      this.loading = false;
      this.isDisabled = false;
    }
  }

  private buildBody(row: any) {
    const invoiceType = row.comentario === 'Exenta' ? 'FACTEX' : 'FACT';
    return {
      invoice: {
        invoiceCode: row.id,
        cdc: row.invoiceAuthorization,
        invoiceType
      },
      transmitter: {
        transmitterPrefix: this.company.companyPrefix,
        transmitterToken: this.company.companyToken
      }
    };
  }

  // Nombre: factura-{cliente}-{correlativo}.pdf — sin caracteres inválidos en nombres de archivo
  private buildFileName(row: any): string {
    const sanitize = (str: string) =>
      (str || '').toString().replace(/[/\\:*?"<>|]/g, '').trim();
    return `factura-${sanitize(row.cliente)}-${sanitize(row.correlativo.toString())}`;
  }

  async downloadUrlS3(urlFirmada: string, nombreFile: string, format: string) {
    const response = await fetch(urlFirmada);
    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = urlBlob;
    link.download = nombreFile + '.' + format;
    link.click();
    window.URL.revokeObjectURL(urlBlob);
  }

  async downloadToExcel() {
    const exportFile = new Array<any>();
    this.temp.forEach(element => {
      let json = {};
      Object.keys(this.settings.columns).forEach(item => {
        if (this.settings.columns[item].type === 'number') {
          json[this.settings.columns[item].title] = parseFloat(element[item]);
        } else {
          json[this.settings.columns[item].title] = element[item];
        }
      });
      exportFile.push(json);
    });
    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(exportFile);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Reporte');
    xlsx.writeFile(wb, 'reporte-regeneracion-masiva.xlsx');
  }
}
